import { Injectable } from '@angular/core';
import { APP_CONSTANTS } from './language.service';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  setThemeVariables(theme: Record<string, string>): void {
    const root = document.documentElement;
    for (const [key, value] of Object.entries(theme)) {
      root.style.setProperty(`--${key}`, value);
    }
  }

 
}

export const orgThemes: Record<string, Record<string, string>> = {
  waste: {
    'primary-color': '#a6d26e',
    'primary-100': '#a6d26e',
    'primary-200': '#a6d26e',
    'primary-400': '#a6d26e',
    'primary-500': '#6bb40e',
    'primary-600': '#6bb40e',
    'primary-700': '#6bb40e',
    'primary-50': '#cdeba6',
  },
  facility: {
    'primary-color': '#1e90ff',
    'primary-100': '#1e90ff',
    'primary-200': '#1e90ff',
    'primary-400': '#1e90ff',
    'primary-500': '#0077cc',
    'primary-600': '#0077cc',
    'primary-700': '#005fa3',
    'primary-50': '#d0e8ff',
  },
  waterdistribution: {
    'primary-color': '#008bff',
    'primary-100': '#008bff',
    'primary-200': '#008bff',
    'primary-400': '#008bff',
    'primary-500': '#0070cd',
    'primary-600': '#0070cd',
    'primary-700': '#1868a7',
    'primary-50': '#f3f8fc',
  },
   default: {
    'primary-color': '#4f008c',
    'primary-100': '#e7cbec',
    'primary-200': '#d4a2dd',
    'primary-400': '#af50bf',
    'primary-500': '#9c27b0',
    'primary-600': '#852196',
    'primary-700': '#6d1b7b',
    'primary-50': '#faf4fb',
  },

};
